import React, {FC} from 'react';
import styles from './ErrorPageComponents.module.scss'
import Link from "next/link";

interface ErrorPageComponentsProps {
    error: Error & { digest?: string };
    reset: () => void;
}

export const ErrorPageComponents: FC<ErrorPageComponentsProps> = ({error, reset}) => {
    const onReset = () => reset();

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>Возникла непредвиденная ошибка</h2>
            <h3 className={styles.subtitle}>Мы ее уже устраняем</h3>
            <div className={styles.row}>
                <Link className={styles.btn} href={'/'}>Главная страница</Link>
                <button className={styles.btn} onClick={onReset}>Обновить страницу</button>
            </div>
        </div>
    );
};